import { defineComponent, ref, reactive, onMounted, toRefs } from 'vue';
import TransLogTabs from "../components/TransLogTabs";
import TransLogTables from "../components/TransLogTables";
export default {
  name: "Uploading",
  components: {
    TransLogTabs,
    TransLogTables
  },
  setup() {
    const data = {
      columns: [{
        label: '文件名称',
        prop: 'fileName'
      }, {
        label: '需求名称',
        prop: 'demandName'
      }, {
        label: '文件大小',
        prop: 'handleSize'
      }],
      startBtn: '暂停',
      cancelBtn: '取消',
      actionType: '1',
      uploadBtn: '继续上传'
    };
    return {
      ...toRefs(data)
    };
  }
};